/**
 * Return current app Locale
 */
export const getLocale = (): string => "en-CA"; // TODO: connect with app state
